'use strict';

angular.module('msLegacyActivities').controller('ActivityCtrl', ['$scope', 'activity', 'widgetSvc', 'activitySvc', 'sharedAnswerSvc', 'NotifyingSvc', '$state', 'smoothScroll', '$timeout', function ($scope, activity, widgetSvc, activitySvc, sharedAnswerSvc, NotifyingSvc, $state, smoothScroll, $timeout) {
  $scope.activity = activity;
  $scope.totalSections = parseInt($scope.activity.sectionCount);
  NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ACTIVITY_STARTED, {
    activity: activity
  });

  $scope.activityImageBackground = {
    'background-image': 'url(/assets/img/squaresOverlay.png), url(' + $scope.activity.image + ')'
  };

  $scope.findResponse = function (widgetUuid) {
    var widget = widgetSvc.getByUuid($scope.activity, widgetUuid);
    return !widget ? '' : widget.response;
  };

  $scope.sharable = !!$scope.activity.promotedWidget;

  $scope.save = function () {
    return activitySvc.saveResponses($scope.activity).then(function () {
      $timeout(function () {
        $state.go('activity.done');
        smoothScroll($('body')[0], {
          duration: 750
        });
      }, 1500);
    });
  };

  $scope.helpDrawerVisible = false;

  $scope.openHelpDrawer = function () {
    $scope.helpDrawerVisible = true;
  };

  $scope.closeHelpDrawer = function () {
    $scope.helpDrawerVisible = false;
  };

  sharedAnswerSvc.getExamples($scope.activity).then(function (dat) {
    return $scope.examples = dat;
  });
}]);